var initFunds = function () {
  if ($('.funds-page').length) {
    var $fundCategories = $('.funds-category');

    if ($fundCategories.length) {
      $.each($fundCategories, function () {
        var $table = $(this),
          tableID = $table.attr('id'),
          options = {
            valueNames: ['sort-name', 'sort-currency', 'sort-price', 'sort-1-month', 'sort-3-months', 'sort-4-months', 'sort-6-months', 'sort-1-year', 'sort-3-years', 'sort-risk', 'sort-date'],
            listClass: 'list',
            sortClass: 'sort',
          },
          tableList = new List(tableID, options);
      });
    }

  }
};

$(document).ready(function () {
  initFunds();
});
